import { createRoot } from 'react-dom/client'
import { useState, useEffect, useRef } from 'react'
import './styles.css'
import App from './App'

const lines = [
  'malaya.',
  'im still traumatized from that witch biting my neck in my sleep',
  'so i need u to come protect me',
]

function Typewriter({ text }) {
  const [displayed, setDisplayed] = useState('')
  const idx = useRef(0)

  useEffect(() => {
    setDisplayed('')
    idx.current = 0
    const interval = setInterval(() => {
      if (idx.current < text.length) {
        setDisplayed(text.slice(0, idx.current + 1))
        idx.current++
      } else {
        clearInterval(interval)
      }
    }, 40)
    return () => clearInterval(interval)
  }, [text])

  return (
    <>
      {displayed}
      <span className="cursor">|</span>
    </>
  )
}

function Overlay() {
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((c) => (c + 1) % lines.length)
    }, 4500)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="overlay">
      <div className="tag top-left">for malaya</div>
      <div className="center-text" key={current}>
        <Typewriter text={lines[current]} />
      </div>
      <div className="tag bottom-right">friday</div>
    </div>
  )
}

createRoot(document.getElementById('root')).render(
  <>
    <App />
    <Overlay />
  </>
)
